import type { ToolMeta } from './registry';

export const searchWeddingKnowledgeMeta = {
  description:
    'Searches the Bridebook knowledge base for advice on budgets, timelines, ceremonies, suppliers, and planning best practices.',
  examples: [
    'How do I plan my wedding budget?',
    'What questions should I ask a photographer?',
    'When should we book our venue?',
  ],
  value: 'an answer to almost any wedding question, from real UK data',
} as const satisfies ToolMeta;
